export const colors = {

    dark: "#01215C",
    dark2: "#302a58",
    bg1: "#e5f3ff",
    bg2: "#f5fdff",
    gr_bg: "linear-gradient(90deg, #312EB1 0%, #00b6ec  100%)",
    gr_bg2: "linear-gradient(90deg, #00b6ec 0%, #312EB1 100%)",
    copy_bg: "#122340",
    blue: "#00b6ec",
    blue2: "#312EB1",
    blue3: "#0AA1D6",
    blue4: "#46C6CE",
    blue5: "#007CFB",
    blue6: "#2E96DB",
    blue7: "#35B3F1",
    blue8: "#4BA0E8",
    n_blue: "#183f6f",
    green: "#11B67A",
    green2: "#00a76a",
    red: "#FA4949",
    purple: "#84479c",
    yellow: "#fbab19",
    black1: "#182B49",
    black2: "#444444",
    text1: "#555555",
    text2: "#666666",
    text3: "#969696",
    text4: "#aaaaaa",
    text5: "#cccccc",
    border1: "#eeeeee",
    border2: "#3e3e3e",
    border3: "#dddddd",
    footer1: "#1a1b25",
    footer2: "#16171f",
    ftext: "#8D8E92"

}

export const fonts = {

    livvic: "'Livvic', sans-serif",
    karla: "'Karla', sans-serif"

}